module.exports = __webpack_public_path__ + "static/31st-3f435b3937c6bf8e84c49422320116fa.png";